import { render, staticRenderFns } from "./ImageToolbarMenu.vue?vue&type=template&id=7f0bd50a"
import script from "./ImageToolbarMenu.vue?vue&type=script&lang=js"
export * from "./ImageToolbarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports